import Home from '../containers/Home/Home';

const routes = [{ path: '/', exact: true, component: Home }];

export default routes;
